import { Component, OnInit } from '@angular/core';
import { SigninService } from '../signin/signin.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SigninResponseVO, SigninRequestVO } from "../signin/signin.models";
import { SsoService } from '../sso/sso.service';
import { UserVO } from '../sso/sso.models';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ResetPasswordRequestVO } from './resetpassword.model';
import { ProfileService } from './profile.service';
import { ApplicationError } from '../common/error.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  private signinResponse: UserVO;
  private resetPasswordForm: FormGroup;
  private editProfileForm: FormGroup;
  private dateToday: Date;
  statusMsgPassword: string;
  statusMsgEdit: string;
  statusMsgProfile: string;
  showHide: boolean;

  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute, 
              private router: Router,
              private ssoService: SsoService,
              private datePipe: DatePipe,
              private profileService: ProfileService) {
  }

  ngOnInit() {
    this.showHide = false;
    this.dateToday = new Date();
    this.signinResponse = this.ssoService.getUserDetails();
    if(this.signinResponse!=null) 
      this.getAndUpdateUserDetails();
    this.resetPasswordForm = this.formBuilder.group({
      oldPassword: [null, Validators.required],
      newPassword: [null, Validators.required],
      confirmPassword: [null, Validators.required]
    });
    //this.route.params.subscribe(params => this.signinResponse = JSON.parse(params['signinResponse']));
  }

  getAndUpdateUserDetails(){
    this.profileService.getUserDetails().then(
      userDeatails => {
        console.log('signinResponseVO = '+ JSON.stringify(userDeatails));
        this.signinResponse = this.ssoService.getUserDetails();
        this.editProfileForm = this.formBuilder.group({
          firstName: [this.signinResponse.getFirstName()],
          lastName: [this.signinResponse.getLastname()],
          emailId: [this.signinResponse.getEmailId()],
          username: [this.signinResponse.getUsername()],
          dob: [this.datePipe.transform(this.signinResponse.getDOB(), 'yyyy-MM-dd')],
          phoneMobile: [this.signinResponse.getPhoneMobile()],
          phoneLandline: [this.signinResponse.getPhoneLandline()]
        });
      },
      errorResponse => {
        if(errorResponse instanceof ApplicationError){
          this.checkForTokenExpiry(errorResponse.statusCode);
          this.statusMsgProfile = errorResponse.statusMsg;
        };
      }
    );
  }

  submitForm(form: any): void {
    let resetPasswordRequestVO = new ResetPasswordRequestVO();
    resetPasswordRequestVO.setOldPassword(this.resetPasswordForm.value.oldPassword);
    resetPasswordRequestVO.setNewPassword(this.resetPasswordForm.value.newPassword);
    resetPasswordRequestVO.setConfirmPassword(this.resetPasswordForm.value.confirmPassword);
    this.resetPasswordForm.reset();
    this.profileService.resetPassword(resetPasswordRequestVO).then(
      resetResponse => {
        this.statusMsgPassword = "Password Successfully Changed";
      },
      errorResponse => {
        this.statusMsgPassword = "Unknown Error";
        if(errorResponse instanceof ApplicationError){
          console.log(errorResponse);
          this.checkForTokenExpiry(errorResponse.statusCode);
          this.statusMsgPassword = errorResponse.statusMsg;
        };
      }
    );
  }

  submitEditProfileForm(form: any): void{
    let userVo = new UserVO();
    userVo.setFirstName(this.editProfileForm.value.firstName);
    userVo.setLastName(this.editProfileForm.value.lastName);
    userVo.setEmailId(this.editProfileForm.value.emailId);
    userVo.setUsername(this.editProfileForm.value.username);
    userVo.setPhoneMobile(this.editProfileForm.value.phoneMobile);
    userVo.setPhoneLandline(this.editProfileForm.value.phoneLandline);
    if(this.editProfileForm.value.dob!=""&&this.editProfileForm.value.dob!=null){
      var d = new Date(this.editProfileForm.value.dob);
      userVo.setDOB(new Date(d.toISOString()));
    }
    this.profileService.editUser(userVo).then(
      editResponse => {
        this.statusMsgEdit = "User Information Successfully updated";
        this.getAndUpdateUserDetails();
      },
      errorResponse => {
        this.statusMsgEdit = "Unknown Error";
        if(errorResponse instanceof ApplicationError){
          console.log(errorResponse);
          this.checkForTokenExpiry(errorResponse.statusCode);
          this.statusMsgEdit = errorResponse.statusMsg;
        };
      }
    );
  }

  logout(){
    this.ssoService.clear();
    this.router.navigate(['/signin']);
  }

  checkForTokenExpiry(errorResponse: any){
    console.log("From check for token expiry" + errorResponse);
    if(errorResponse === "TOKEN_EXPIRED"){
      this.logout();
      alert("Session timed out... Please log in again to continue");
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts